import React from 'react';
import { Button } from './ui/Button';
import { Sparkles } from 'lucide-react';
export function Transformation() {
  return <section className="py-16 md:py-24 px-4 max-w-4xl mx-auto" data-id="element-409">
      <div className="text-center mb-8" data-id="element-410">
        <p className="text-primary font-bold uppercase tracking-widest text-[11px] md:text-sm mb-3 flex items-center justify-center gap-2" data-id="element-411">
          <Sparkles className="w-4 h-4" data-id="element-412" /> La transformación
        </p>
        <h2 className="text-2xl md:text-4xl font-extrabold leading-tight max-w-3xl mx-auto" data-id="element-413">
          ¿Y si este fuera el{' '}
          <span className="text-primary" data-id="element-414">último domingo que pasás así?</span>
        </h2>
      </div>

      <div className="relative bg-gradient-to-b from-surface to-surface/40 border border-primary/30 rounded-3xl p-6 md:p-10 mb-8 shadow-[0_0_40px_rgba(74,222,128,0.08)]" data-id="element-415">
        <p className="text-base md:text-xl text-zinc-200 leading-relaxed text-center mb-6" data-id="element-416">
          Imaginá esto:
        </p>
        <p className="text-base md:text-xl text-white text-center leading-relaxed mb-6 font-medium" data-id="element-417">
          El próximo domingo abrís el tomo del mes, leés la clase del día,
          ajustás según tu grupo… y listo.
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-6" data-id="element-418">
          {['Sin buscar.', 'Sin armar.', 'Sin improvisar.', 'Sin arrancar de cero.'].map((line, i) => <div key={i} className="bg-black/40 border border-primary/20 rounded-xl p-3 md:p-4 text-center text-sm md:text-base font-bold text-primary" data-id="element-419">
              {line}
            </div>)}
        </div>

        <p className="text-base md:text-lg text-zinc-300 text-center max-w-2xl mx-auto leading-relaxed" data-id="element-420">
          Eso es exactamente lo que hace el{' '}
          <span className="text-white font-bold" data-id="element-421">
            Combo Completo de E. Funcional.
          </span>
        </p>
      </div>

      <div className="text-center" data-id="element-422">
        <Button href="#pricing" className="text-base md:text-xl py-3.5 md:py-4 px-6 md:px-10 w-full md:w-auto" data-id="element-423">
          👉 QUIERO VER EL COMBO
        </Button>
      </div>
    </section>;
}